import {Injectable} from '@angular/core';
import * as _ from 'lodash';
import {Aspect} from '../models/aspect.model';
import { HttpParams } from '@angular/common/http';
import { ApiService } from './api.service';

import { environment } from '../../environments/environment';
import { AspectType } from '../constants/aspect-type.const';

@Injectable()
export class RoleService {

    api_url: string;

    constructor(private apiService: ApiService) {
        this.api_url = environment.cdt.api_url;
    }

    fetchWithoutPointsCount(siteId: string, aspects?: Aspect[]) {
        let params = new HttpParams().set('siteId', siteId).set('enrichPointsCount', 'false');
        const aspectsByType = _.groupBy(aspects, aspect => aspect.typeIri);
        _.forEach(aspectsByType[AspectType.ELEMENT_TYPE], aspect => params = params.append('elementTypeAspects', aspect.valueIri));
        _.forEach(aspectsByType[AspectType.MEASURE_TYPE], aspect => params = params.append('measureTypeAspects', aspect.valueIri));
        _.forEach(aspectsByType[AspectType.MATERIAL_TYPE], aspect => params = params.append('materialTypeAspects', aspect.valueIri));
        return this.apiService.get('/roles', this.api_url , params);
    }

    fetchWithPointsCount(siteId: string, aspects?: Aspect[]) {
        let params = new HttpParams().set('siteId', siteId).set('enrichPointsCount', 'true');
        const aspectsByType = _.groupBy(aspects, aspect => aspect.typeIri);
        _.forEach(aspectsByType[AspectType.ELEMENT_TYPE], aspect => params = params.append('elementTypeAspects', aspect.valueIri));
        _.forEach(aspectsByType[AspectType.MEASURE_TYPE], aspect => params = params.append('measureTypeAspects', aspect.valueIri));
        _.forEach(aspectsByType[AspectType.MATERIAL_TYPE], aspect => params = params.append('materialTypeAspects', aspect.valueIri));
        return this.apiService.get('/roles', this.api_url , params);
    }
}
